export default function ({ store, redirect }) {
  if (store.getters['user/isPortalUser'] && store.state['user']?.currentLogin?.goals_enabled === false) {
    return redirect('/');
  }
}
